import React, { FC, useEffect } from "react";
import { logEvent } from "../../../../helpers/analytics";
import Button from "@laborhack/custom-button";
import { Icon } from "semantic-ui-react";

export interface ArtisanSignUpProps {}

export const ArtisanSignUp: FC<ArtisanSignUpProps> = ({}) => {
  useEffect(() => {
    logEvent("viewed_artisan_waitlist_form");
  }, []);
  return (
    <div>
      <h3 className="text-primary-500 font-bold">Artisan Sign Up</h3>
      <a href={process.env.REACT_APP_PRO_APPLICATION_URL}>
        <Button type="link">
          Continue at pro.laborhack.com <Icon name="external alternate" />
        </Button>
      </a>
    </div>
  );
};
